import { takeEvery, put, call } from "redux-saga/effects"
import { put as apiPut } from "api"
import { Types as DataTypes } from "model/data"
import { Creators } from "../../reducers/app/recentInstruments"

export const RECENT_INSTRUMENTS_RESOURCE = "recentInstruments"

// Recent instruments are shared across the application, so we need to decouple them from specific modules
function* handleSetRecentInstruments(action) {
  if (action.resource === RECENT_INSTRUMENTS_RESOURCE) {
    yield put(Creators.setRecentInstruments(action.data))
  }
}

export function* handleUpdateRecentInstruments(account, instrumentId, instrumentType, searchType, { modelId, skipModelId } = {}) {
  try {
    if ((modelId || skipModelId) && account) {
      const url = skipModelId
        ? `/api/${account}/recent-instruments`
        : `/api/${account}/recent-instruments?${new URLSearchParams({ modelId })}`

      const instrument = yield call(
        apiPut,
        url,
        { instrumentId, instrumentType, searchType },
      )
      yield put(Creators.updateRecentInstrument({ type: instrument.type, searchType, ...instrument }))
    }
  } catch {
    // If query returns an error, do nothing
  }
}

export default function* recentInstrumentsSaga() {
  yield takeEvery(DataTypes.LOAD_SUCCESS, handleSetRecentInstruments)
}
